import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChangePasswordForm } from '../components/change-passowrd';
import { AuthPageShell } from '../layout/auth-page-shell';
import { Card } from '@aurrica-web/ui';
import { AuthFormHeader } from '../layout/auth-form-header';

@Component({
  selector: 'lib-auth-change-password-page',
  imports: [ChangePasswordForm, AuthPageShell, Card, AuthFormHeader],
  template: `
    <lib-auth-page-shell>
      <lib-ui-card class="bg-white dark:bg-background-dark shadow-md rounded-md">
        <lib-auth-form-header title="Change Password" />
        <lib-auth-change-password-form />
      </lib-ui-card>
    </lib-auth-page-shell>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordPage {}
